export const API_BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:9010";

export const ENQUIRY_ENDPOINT = `${API_BASE_URL}/honesti-digital-enquiry`;
